<template>
  <div
    v-if="scheduleCallout && scheduleCallout.eodTitle && scheduleCallout.eodSubtitle"
    class="flex flex-col text-center mx-auto gap-2 w-[303px] md:w-[80%] text-[20px] leading-[24px] text-grey-80"
  >
    <p class="font-aktiv-grotesk-medium">
      <html-to-vue class="pb-2" :html="scheduleCallout.eodTitle"></html-to-vue>
    </p>
    <p class="font-aktiv-grotesk-regular">
      <html-to-vue :html="scheduleCallout.eodSubtitle"></html-to-vue>
    </p>
  </div>
</template>

<script>
export default {
  name: 'EodPanelCMS',
  props: {
    scheduleCallout: {
      type: Object,
      default: () => null,
    },
  },
};
</script>
